<script>
  import { project } from "$lib/services/store.js";
  import { browser } from "$app/environment";
  import Icons from "$lib/main/components/Icons.svelte";
  import Translate from '$lib/admin/components/blocks/helpers/Translate.svelte';

  export let data;
  const { operator, special } = data

  const links = operator.aff_links?.[$project.key][$project.settings.market]
  let goLink = links?.default || "https://" + operator.url

  if (special && special.hasOwnProperty(links)) {
    goLink = links[special] || "https://" + operator.url
  }

  if (browser) {
    // TODO: add back redirect after development is finished
    // window.location.href = goLink
  }
</script>

<svelte:head>
  <meta name="robots" content="noindex, noarchive">
</svelte:head>

<div class={ "redirecting-page t-" + $project.settings.theme + " p-" + $project.key }>
  <div class="holder">
    <div class="block block-redirect">
      <h2><Translate text="Thank you for visiting" /> {$project.settings.domain}</h2>
      <div class="logos">
        <img alt={$project.name} class="project" src={ $project.data?.imageFolders.assets + $project.name_lower + "-icon.png?w=100&q=85&auto=format"}>
        <Icons name="chevron-right" width="48px" height="48px" />
        <img alt={operator.name} class={ "operator _" + operator["name_lower"] } src={ $project.data?.imageFolders?.operators + operator.name_lower + ".png?w=100&q=85&auto=format" }>
      </div>
      <p><a href={goLink}><Translate text="Click here" /></a> <Translate text="if you aren't forwarded to" /> {operator.name}</p>
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
  </div>
</div>